import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listVersions = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/version/listVersions", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });

export const createVersion = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/version/createVersion", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateVersion = async (
  companyId: string,
  companyType: string,
  id: number,
  payload: Record<string, any>
) =>
  post("projectService/version/updateVersion", {
    company_id: companyId,
    company_type: companyType,
    id,
    ...payload,
  });

export const releaseVersion = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/version/releaseVersion", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const archiveVersion = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/version/archiveVersion", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const unarchiveVersion = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/version/unarchiveVersion", {
    company_id: companyId,
    company_type: companyType,
    id,
  });
